// import { FaBriefcase, FaCalendarAlt } from 'react-icons/fa';

// const ExperienceCard = ({ role, company, duration, description }) => {
//   return (
//     <div className='flex items-start gap-4'>
//       {/* Step Icon */}
//       <div className='flex items-center justify-center w-10 h-10 bg-primary text-white rounded-full shadow-md'>
//         <FaBriefcase size={20} />
//       </div>

//       {/* Content */}
//       <div>
//         {/* Role & Company */}
//         <h3 className='text-xl font-bold text-gray-200'>
//           {company} — {role}
//         </h3>

//         {/* Duration */}
//         <p className='text-gray-400 flex items-center gap-2 text-sm mb-2'>
//           <FaCalendarAlt size={16} /> {duration}
//         </p>

//         {/* Description */}
//         <ul className='list-disc pl-5 text-gray-300 text-sm space-y-1'>
//           {description.map((item, index) => (
//             <li key={index}>{item}</li>
//           ))}
//         </ul>
//       </div>
//     </div>
//   );
// };

// export default ExperienceCard;

import { FaBriefcase, FaCalendarAlt } from 'react-icons/fa';
import { motion } from 'framer-motion';

const ExperienceCard = ({ role, company, duration, description }) => {
  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: 'easeOut' },
    },
  };

  const iconVariants = {
    hidden: { scale: 0 },
    visible: { scale: 1, transition: { duration: 0.4, ease: 'easeInOut' } },
  };

  return (
    <motion.div
      className='flex items-start gap-4'
      initial='hidden'
      whileInView='visible'
      viewport={{ once: true, amount: 0.2 }}
      variants={cardVariants}
    >
      {/* Step Icon */}
      <motion.div
        className='flex items-center justify-center w-10 h-10 bg-primary text-white rounded-full shadow-md'
        variants={iconVariants}
      >
        <FaBriefcase size={20} />
      </motion.div>

      {/* Content */}
      <div>
        {/* Role & Company */}
        <h3 className='text-xl font-bold text-gray-200'>
          {company} — {role}
        </h3>

        {/* Duration */}
        <motion.p
          className='text-gray-400 flex items-center gap-2 text-sm mb-2'
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.5 }}
        >
          <FaCalendarAlt size={16} /> {duration}
        </motion.p>

        {/* Description */}
        <motion.ul
          className='list-disc pl-5 text-gray-300 text-sm space-y-1'
          initial='hidden'
          animate='visible'
          variants={{
            hidden: { opacity: 0, x: -20 },
            visible: {
              opacity: 1,
              x: 0,
              transition: { delayChildren: 0.4, staggerChildren: 0.1 },
            },
          }}
        >
          {description.map((item, index) => (
            <motion.li
              key={index}
              variants={{ hidden: { opacity: 0 }, visible: { opacity: 1 } }}
            >
              {item}
            </motion.li>
          ))}
        </motion.ul>
      </div>
    </motion.div>
  );
};

export default ExperienceCard;
